import React from 'react';
import { Input } from 'reactstrap';
import { onChange as onChangeUtil } from '~appointments/utils/utils';

import { InputProps } from '~components/form-fields';

interface ComponentProps extends InputProps {
  setFieldValue?: any;
  setFieldTouched?: any;
}

const FullSizeNotes: React.FC<ComponentProps> = ({ value, id, setFieldValue, setFieldTouched }) => {
  return (
    <div className="p-2 me-4">
      <span className="fw-bold ps-1">Notes:</span>
      <Input
        id={id}
        name={id}
        className="full-size-notes"
        data-cy="notes-input"
        type="textarea"
        value={value}
        onChange={(event) => onChangeUtil(event, setFieldTouched, setFieldValue)}
      />
    </div>
  );
};

export default FullSizeNotes;
